import { useEffect, useState } from 'react';

import type { ContentStatus as BoardStatus } from '@confluence/content-types-header/entry-points/ContentStatus.tsx';
import type { MoreActions } from '@confluence/content-types-header/entry-points/MoreActions.tsx';
import type { MainActions } from '@confluence/content-types-header/entry-points/MainActions.tsx';
import { contentMoreActionsService } from '@confluence/content-types-bridge/entry-points/content-more-actions-service.ts';
import { contentMainActionsService } from '@confluence/content-types-bridge/entry-points/content-main-actions-service.ts';
import { contentCollaboratorsService } from '@confluence/content-types-bridge/entry-points/content-collaborators-service.ts';
import { contentBoardStatusService } from '@confluence/content-types-bridge/entry-points/content-board-status-service.ts';
import type { CanvasCollaborators } from '@confluence/team-presence/entry-points/presenceTypes.ts';

export const useDatabaseHeaderActions = (): {
	mainActions: MainActions | null;
	collaborators: CanvasCollaborators;
	contentStatus: BoardStatus | null;
	moreActions: MoreActions | null;
} => {
	const [mainActions, setMainActions] = useState<MainActions | null>(null);
	const [collaborators, setCollaborators] = useState<CanvasCollaborators>({
		collaborators: [],
		me: null,
	});
	const [boardStatus, setBoardStatus] = useState<BoardStatus | null>(null);
	const [moreActions, setMoreActions] = useState<MoreActions | null>(null);

	useEffect(() => {
		contentMainActionsService.onActionsUpdate((mainAction) => {
			setMainActions(mainAction);
		});

		contentCollaboratorsService.onActionsUpdate((collaborator) => {
			setCollaborators(collaborator);
		});

		contentBoardStatusService.onActionsUpdate((status) => {
			setBoardStatus(status);
		});

		contentMoreActionsService.onActionsUpdate((moreAction) => {
			setMoreActions(moreAction);
		});
	}, [setMainActions, setCollaborators, setBoardStatus, setMoreActions]);

	return {
		mainActions,
		collaborators,
		contentStatus: boardStatus,
		moreActions,
	};
};
